import { render, staticRenderFns } from "./PrecintoIndex.vue?vue&type=template&id=4660789e"
import script from "./PrecintoIndex.vue?vue&type=script&lang=js"
export * from "./PrecintoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports